import { __assign, __rest } from "tslib";
import React from 'react';
import clsx from 'clsx';
import { createStyles } from '@material-ui/core/styles';
import withStyles from '@material-ui/core/styles/withStyles';
import { default as MuiDialogTitle } from '@material-ui/core/DialogTitle';
import { Close } from '../../internal/icons/medium';
import { Typography } from '../Typography';
import { IconButton } from '../IconButton';
export var styles = function () {
    return createStyles({
        closeButton: {
            position: 'relative',
            right: '-6px',
        },
    });
};
export var DialogTitle = React.forwardRef(function (props, ref) {
    var ariaDescribedby = props.ariaDescribedby, classes = props.classes, disableTypography = props.disableTypography, children = props.children, hideCloseButton = props.hideCloseButton, id = props.id, isAlert = props.isAlert, closeLabel = props.closeLabel, closeButtonProps = props.closeButtonProps, onClose = props.onClose, className = props.className, other = __rest(props, ["ariaDescribedby", "classes", "disableTypography", "children", "hideCloseButton", "id", "isAlert", "closeLabel", "closeButtonProps", "onClose", "className"]);
    var combinedClassName = clsx(className, 'bb-dialog-title');
    return (React.createElement(MuiDialogTitle, __assign({ className: combinedClassName, disableTypography: true, ref: ref }, other),
        disableTypography && children,
        !disableTypography && (React.createElement(Typography, { variant: "h1", id: id, tabIndex: -1, className: "bb-h1-element", "aria-describedby": isAlert ? ariaDescribedby : undefined }, children)),
        !hideCloseButton && (React.createElement(IconButton, __assign({ className: classes.closeButton, "aria-label": closeLabel, onClick: onClose }, closeButtonProps),
            React.createElement(Close, null)))));
});
DialogTitle.defaultProps = {
    closeLabel: 'Close',
};
export default withStyles(styles)(DialogTitle);
//# sourceMappingURL=DialogTitle.js.map